import React from "react";

//Import PageHeader
// import { useHistory } from "react-router";
// import AccountsBoard from "./AccountsBoard";
import PageHeader from "../../../components/PageHeader";
import { useSelector } from "react-redux";
import { isManagerCompany } from "../../../utils/auth";
import TaxCompanySchedule from "../../../components/TaxPortal/TaxDashboard/TaxCompanySchedule";
import TaxContacts from "../../../components/TaxPortal/TaxContacts";

// Board
// ADMIN = 관리자, SUB_ADMIN = 경리 , NORMAL = 일반유저

const TaxDashboard = (props) => {
  // const role = "ADMIN";
  // const history = useHistory();

  const { user, employee } = useSelector(
    (store) => ({
      user: store.Profile.user,
      employee: store.Profile.employee,
    }),
  );

  return (
    <div className="tax-portal">
      <PageHeader title={`${employee && employee.name}님, 안녕하세요`} />
      {user?.type > 1 && (
        <>
          {isManagerCompany() && <TaxContacts />}
          <TaxCompanySchedule />
        </>
      )}
    </div>
  );
};

export default TaxDashboard;
